import React, { useEffect } from "react";
import classes from "./dashboard.module.css";
import {
  Paper,
  Typography,
  Avatar,
  Divider,
  Button,
} from "@mui/material";
import DonutChart from "./DonutChart";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Customers from "../Customer/Customers";
import {
  getCustomerPieChartDetails,
  getSubscriptionPieChartDetails,
  getSupportTicketPieChartDetails,
} from "../../../Redux/actions/piechartActions";
import { useState } from "react";
import dayjs from "dayjs";
import { DatePickerCalendarIcon } from "../../../Components/Icons/Icons";
import { paginationEdit } from "../../../Redux/actions/customerActions";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Homepage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const { ativeCustomer, subscriptionpiechart, supportTicket } = useSelector(
    (state) => state.piechartData
  );

  const act_subs =
    subscriptionpiechart?.total > 0
      ? Math.floor(
          ((subscriptionpiechart?.active + subscriptionpiechart?.expiry_soon) /
            subscriptionpiechart?.total) *
            100
        )
      : 0;
  const act_subs_count = subscriptionpiechart?.total;
  const download = subscriptionpiechart?.downloads || 0;

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const formattedFrom = fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : undefined;
    const formattedTo = toDate ? dayjs(toDate).format("YYYY-MM-DD") : undefined;
    dispatch(getCustomerPieChartDetails(formattedFrom, formattedTo));
    dispatch(getSubscriptionPieChartDetails(formattedFrom, formattedTo));
    dispatch(getSupportTicketPieChartDetails(formattedFrom, formattedTo));
  }, [dispatch, fromDate, toDate]);

  useEffect(() => {
    dispatch(paginationEdit(10, 1));
  }, [fromDate]);

  // ----- Chart data (Recharts format: { name, value }) -----
  const inactivePct = subscriptionpiechart?.total > 0 ? 100 - act_subs : 0;

  const customerChart = [
    { name: "Inactive", value: Number(ativeCustomer?.in_active) || 0 },
    { name: "Active", value: Number(ativeCustomer?.active) || 0 },
  ];
  const subPctChart = [
    { name: "Inactive", value: inactivePct },
    { name: "Active", value: act_subs },
  ];
  const subBreakdownChart = [
    { name: "Resubscribed", value: Number(subscriptionpiechart?.active) || 0 },
    { name: "Expiring Soon", value: Number(subscriptionpiechart?.expiry_soon) || 0 },
    { name: "Expired", value: Number(subscriptionpiechart?.expired) || 0 },
  ];
  const mobileChart = [
    { name: "Downloads", value: Number(download) || 0 },
    { name: "Subscriptions", value: Number(act_subs_count) || 0 },
  ];
  const supportChart = [
    { name: "Pending", value: Number(supportTicket?.pending) || 0 },
    { name: "Completed", value: Number(supportTicket?.closed) || 0 },
  ];

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className={classes.datePicker1} style={{ display: "flex", gap: "10px" }}>
          <DesktopDatePicker
            label="From Date"
            value={fromDate}
            onChange={(newValue) => setFromDate(newValue)}
            format="DD/MM/YYYY"
            slots={{ openPickerIcon: DatePickerCalendarIcon }}
            slotProps={{ textField: { size: 'small' } }}
          />
          <DesktopDatePicker
            label="To Date"
            value={toDate}
            onChange={(newValue) => setToDate(newValue)}
            format="DD/MM/YYYY"
            slots={{ openPickerIcon: DatePickerCalendarIcon }}
            slotProps={{ textField: { size: 'small' } }}
          />
        </div>
      </LocalizationProvider>
      <div className={classes.DashboardFirstContainer}>
        <Paper className={classes.Pichart1Container}>
          <Typography className={classes.piechartHEadingMain}>
            Customers
          </Typography>
          <Typography className={`mt-2 ${classes.pieChartSubHEading}`}>
            Daily Active users:{" "}
            <span style={{ color: "#0A1F41", fontWeight: 600 }}>
              {ativeCustomer?.active}
            </span>
          </Typography>
          {ativeCustomer && (
            <div
              className={classes.displayFlex}
              style={{ columnGap: "40px", position: "relative" }}
            >
              <DonutChart
                data={customerChart}
                colors={["#C52A38", "#227DC3"]}
                size={170}
                centerValue={ativeCustomer?.total || 0}
                centerLabel="Total"
              />
              <div>
                <Typography className={classes.displayFlex}>
                  <Avatar
                    sx={{
                      bgcolor: `#227DC3`,
                      width: "12px",
                      height: "12px",
                    }}
                  >
                    {" "}
                  </Avatar>
                  <span className={classes.pieChartSubHEading}>Active</span>
                </Typography>
                <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                  {ativeCustomer?.active}
                </Typography>
                <Typography className={`mt-3 ${classes.displayFlex}`}>
                  <Avatar
                    sx={{
                      bgcolor: `#C52A38`,
                      width: "12px",
                      height: "12px",
                    }}
                  >
                    {" "}
                  </Avatar>
                  <span className={classes.pieChartSubHEading}>Inactive</span>
                </Typography>
                <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                  {ativeCustomer?.in_active}
                </Typography>
              </div>
            </div>
          )}
        </Paper>
        <Paper className={classes.Pichart2Container}>
          <Typography className={classes.piechartHEadingMain}>
            Subscription
          </Typography>
          <Typography className={`mt-2 ${classes.pieChartSubHEading}`}>
            {" "}
          </Typography>
          {subscriptionpiechart && (
            <div className={classes.TwoPieChartContainer}>
              <div
                className={classes.displayFlex}
                style={{ columnGap: "40px", width: "49%" }}
              >
                <DonutChart
                  data={subPctChart}
                  colors={["#C52A38", "#240051"]}
                  size={170}
                  centerValue={`${inactivePct + act_subs}%`}
                  centerLabel="Total"
                  valueSuffix="%"
                />
                <div>
                  <Typography className={classes.displayFlex}>
                    <Avatar
                      sx={{
                        bgcolor: `#240051`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>Active</span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {act_subs}%
                  </Typography>
                  <Typography className={`mt-3 ${classes.displayFlex}`}>
                    <Avatar
                      sx={{
                        bgcolor: `#C52A38`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>Inactive</span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {inactivePct}%
                  </Typography>
                </div>
              </div>
              <Divider
                orientation="vertical"
                flexItem
                style={{
                  height: "155px",
                  borderColor: "#DADEF2",
                  borderWidth: "1px",
                }}
              />
              <div
                className={classes.displayFlex}
                style={{ columnGap: "40px", width: "50%" }}
              >
                <DonutChart
                  data={subBreakdownChart}
                  colors={["#240051", "#227DC3", "#C52A38"]}
                  size={170}
                  centerValue={subscriptionpiechart?.total || 0}
                  centerLabel="Total"
                />
                <div>
                  <Typography className={classes.displayFlex}>
                    <Avatar
                      sx={{
                        bgcolor: `#C52A38`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>Expired</span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {subscriptionpiechart?.expired}
                  </Typography>
                  <Typography className={`mt-2 ${classes.displayFlex}`}>
                    <Avatar
                      sx={{
                        bgcolor: `#227DC3`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>
                      Expiring Soon
                    </span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {subscriptionpiechart?.expiry_soon}
                  </Typography>
                  <Typography className={`mt-2 ${classes.displayFlex}`}>
                    <Avatar
                      sx={{
                        bgcolor: `#240051`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>
                      Resubscribed
                    </span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {subscriptionpiechart?.active}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </Paper>
      </div>
      <div className={classes.DashboardSecondContainer}>
        <Paper className={classes.Pichart3Container}>
          <Typography className={classes.piechartHEadingMain}>
            Mobile App
          </Typography>
          <div className={classes.displayFlex} style={{ columnGap: "40px" }}>
            <DonutChart
              data={mobileChart}
              colors={["#227DC3", "#240051"]}
              size={170}
              centerValue={act_subs_count || 0}
              centerLabel="Total"
            />
            <div className={classes.displayFlex} style={{ columnGap: "40px" }}>
              <div>
                <Typography className={`${classes.displayFlex}`}>
                  <Avatar
                    sx={{
                      bgcolor: `#240051`,
                      width: "12px",
                      height: "12px",
                    }}
                  >
                    {" "}
                  </Avatar>
                  <span className={classes.pieChartSubHEading}>
                    Subscriptions
                  </span>
                </Typography>
                <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                  {act_subs_count || 0}
                </Typography>
              </div>
            </div>
          </div>
        </Paper>
        <Paper className={classes.Pichart3Container}>
          <Typography className={classes.piechartHEadingMain}>
            Support Ticket
          </Typography>
          {supportTicket && (
            <div
              className={classes.displayFlex}
              style={{ columnGap: "40px", position: "relative" }}
            >
              <DonutChart
                data={supportChart}
                colors={["#C52A38", "#227DC3"]}
                size={170}
                centerValue={supportTicket?.total || 0}
                centerLabel="Total"
              />
              <div
                className={classes.displayFlex}
                style={{ columnGap: "40px" }}
              >
                <div>
                  <Typography className={classes.displayFlex}>
                    <Avatar
                      sx={{
                        bgcolor: `#227DC3`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>
                      Completed
                    </span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {supportTicket?.closed}
                  </Typography>
                </div>
                <div>
                  <Typography className={`${classes.displayFlex}`}>
                    <Avatar
                      sx={{
                        bgcolor: `#C52A38`,
                        width: "12px",
                        height: "12px",
                      }}
                    >
                      {" "}
                    </Avatar>
                    <span className={classes.pieChartSubHEading}>Pending</span>
                  </Typography>
                  <Typography className={`mt-2 ${classes.piechartValuyeText}`}>
                    {supportTicket?.pending}
                  </Typography>
                </div>
              </div>
            </div>
          )}
        </Paper>
      </div>
      <div className="mt-3">
        <Box style={{ position: "relative" }}>
          <div>
            <Button
              variant="text"
              className={classes.ViewAllBtn}
              onClick={() => navigate("/customers")}
            >
              View all
            </Button>
          </div>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              className={classes.HeadTabButton}
              aria-label="basic tabs example"
            >
              <Tab
                label={"Subscription Actions"}
                {...a11yProps(0)}
                style={{ textTransform: "capitalize" }}
              />
              <Tab
                label={"Latest Customers"}
                {...a11yProps(1)}
                style={{ textTransform: "capitalize" }}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} className={classes.TabPanel}>
            <Customers fromDate={fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : undefined} toDate={toDate ? dayjs(toDate).format("YYYY-MM-DD") : undefined} />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.TabPanel}>
            <Customers fromDate={fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : undefined} toDate={toDate ? dayjs(toDate).format("YYYY-MM-DD") : undefined} />
          </TabPanel>
        </Box>
      </div>
    </div>
  );
};

export default Homepage;
